<template>
  <div
    class="section-hr"
    :class="{ 'no-hr-padding': noHrPadding, narrow: narrow }"
  >
    <hr color="#DCDDDE" />
  </div>
</template>
<script>
  export default {
    name: 'HR',
    props: {
      noHrPadding: {
        required: false,
        default: false,
        type: Boolean,
      },
      // Matches the 816px adviser content column instead of the 1280px site rule.
      narrow: {
        required: false,
        default: false,
        type: Boolean,
      },
    },
  };
</script>

<style scoped lang="scss">
  .section-hr {
    display: flex;
    justify-content: center;
    margin-top: 88px;
    hr {
      width: 1280px;
      max-width: 60vw;
    }
  }
  .no-hr-padding {
    margin-top: 0;
  }
  .narrow {
    hr {
      width: 816px;
      max-width: 95vw;
    }
  }
</style>
